export const CATEGORIES = "categories";
export const AUTHORS = "authors";
export const TAGS = "tags";

export const TITLE_ONLY_VALUE = "titleOnly";
export const SELECT_ALL_VALUE = "all";
